module.exports = __webpack_public_path__ + "img/recommend-2.489af24f.png";